import EnquiryEdit from "./EnquiryEdit";
import "./EnquiryEdit.scss";

export default EnquiryEdit;
